import { TheNightlySection } from '@news-mono/common'
import { salesforceRedirectPath, StaticRoute, StaticRoutes } from '@news-mono/web-common'

const createEmailPreferencePage: StaticRoute<TheNightlySection> = ({
    config,
    location,
}) => {
    // redirect to a server-side only route to generate a salesforce JWT for logged in users
    return {
        kind: 'redirect',
        redirectTo: {
            httpStatusCode: 302,
            targetUrl: `${config.publicUrl}${salesforceRedirectPath}${location.search}`,
        },
    }
}

export const getEmailPreferenceRouteInfo: StaticRoutes<TheNightlySection> = {
    '/manage-email-preferences': createEmailPreferencePage,
}